import React from 'react';
import * as ClubFormCtx from '../club-form-context';
import { InputFormCheckbox } from '../../../../common/form/form-parts/input-form-checkbox';
import { BusinessTierSelect, BUSINESS_TIERS } from './BusinessTierSelect';
// import S from './features.module.scss';
import { FormNumberField } from '../../../../common/form/form-number-field';
import DurationInput from './DurationInput';
import { useTranslation } from 'react-i18next';

interface Props {
  isDisabled: boolean,
}

const Features: React.FC <Props> = (props) => {
  const { isDisabled } = props;
  const { t } = useTranslation();
  const { dispatch, state: { form: { tier, auditionsEnabled, messageClub, auditionApplicationsMax, auditionDurationMax } }, } = ClubFormCtx.useClubFormCtx();

  return (
    <div className={'flex flex-col w-56 mt-8'}>
        <BusinessTierSelect
          isDisabled={isDisabled}
          value={tier}
          id='club_form_business_tier'
          name='tier'
          handleChange={({ target: { name, value } }) => {
            dispatch(ClubFormCtx.setClubFormField(name, value));
            if(value === BUSINESS_TIERS.PRO) {
              dispatch(ClubFormCtx.setClubFormField('auditionsEnabled', true));
              dispatch(ClubFormCtx.setClubFormField('messageClub', true));
              dispatch(ClubFormCtx.setClubFormField('auditionApplicationsMax', null));
              dispatch(ClubFormCtx.setClubFormField('auditionDurationMax', null));
            } else if (value === BUSINESS_TIERS.BASIC) {
              dispatch(ClubFormCtx.setClubFormField('auditionsEnabled', true));
              dispatch(ClubFormCtx.setClubFormField('messageClub', true));
              dispatch(ClubFormCtx.setClubFormField('auditionApplicationsMax', 0));
              dispatch(ClubFormCtx.setClubFormField('auditionDurationMax', 0));
            } else if (value === BUSINESS_TIERS.UNVERIFIED) {
              dispatch(ClubFormCtx.setClubFormField('auditionsEnabled', false));
              dispatch(ClubFormCtx.setClubFormField('messageClub', false));
              dispatch(ClubFormCtx.setClubFormField('auditionApplicationsMax', 0));
              dispatch(ClubFormCtx.setClubFormField('auditionDurationMax', 0));
            }
          }}
        />
      <div className={'mt-2'}>
        <InputFormCheckbox
          id='club_form_message_club'
          label={t('clubPage.messageClubLabel')}
          name='messageClub'
          isChecked={messageClub}
          isDisabled={isDisabled || tier !== BUSINESS_TIERS.BASIC}
          handleChange={(e) => dispatch(ClubFormCtx.setClubFormField(e.target.name, !messageClub))}
        />

        <InputFormCheckbox
          id='club_form_allow_auditions'
          label={t('clubPage.auditionsEnabledLabel')}
          name='auditionsEnabled'
          isChecked={auditionsEnabled}
          isDisabled={isDisabled || tier !== BUSINESS_TIERS.BASIC}
          handleChange={
            (e) => {
              dispatch(ClubFormCtx.setClubFormField(e.target.name, !auditionsEnabled));
              if (auditionsEnabled) {
                dispatch(ClubFormCtx.setClubFormField('auditionApplicationsMax', 0));
                dispatch(ClubFormCtx.setClubFormField('auditionDurationMax', 0));
              }
            }
          }
        />
      </div>

      {tier === BUSINESS_TIERS.BASIC && auditionsEnabled && (
        <div className={'mt-2'}>
            <FormNumberField
              id='club_form_AuditionsLimit'
              classname={'mt-2'}
              min={0}
              name='auditionApplicationsMax'
              label={t('clubPage.auditionApplicationsMaxLabel')}
              isDisabled={isDisabled}
              value={auditionApplicationsMax}
              handleBlur={({ target: { name, value } }) => {
                dispatch(ClubFormCtx.setClubFormField(name, value.trim()));
              }}
              handleChange={({ target: { name, value } }) => {
                dispatch(ClubFormCtx.setClubFormField(name, value));
              }}
            />
            <DurationInput
              className={'mt-2'}
              id='club_form_auditionDurationMax'
              name={'auditionDurationMax'}
              isDisabled={isDisabled}
              value={auditionDurationMax}
              label={t('clubPage.auditionDurationMaxLabel')}
              onChange={(e) => dispatch(ClubFormCtx.setClubFormField(e.target.name, e.target.value))}
            />
        </div>
      )}
    </div>
  );
};

export default Features;
